import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../profile/constants';

const lazy = {
    EditContactDetailsPage: lazyLoad(async () => {
        const { EditContactDetails } = await import('./EditContact');

        return { default: EditContactDetails };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.edit-contact-details.title',
        page: lazy.EditContactDetailsPage,
        path: route.patterns.individualUser.contactDetails.edit,
    },
];
